"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/* picture как контейнер не может принять onClick */
/* так что onClick сработает именно на img */

var Image = function Image(_ref) {
  var src = _ref.src,
    fallback = _ref.fallback,
    alt = _ref.alt,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'image/webp' : _ref$type,
    className = _ref.className,
    onLoad = _ref.onLoad,
    onClick = _ref.onClick,
    onError = _ref.onError,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'eager' : _ref$loading,
    _ref$fetchpriority = _ref.fetchpriority,
    fetchpriority = _ref$fetchpriority === void 0 ? 'auto' : _ref$fetchpriority;
  return /*#__PURE__*/_react["default"].createElement("picture", null, /*#__PURE__*/_react["default"].createElement("source", {
    srcSet: src,
    type: type,
    "data-testid": 'image-source-test-id'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: fallback,
    alt: alt,
    className: className,
    onLoad: onLoad,
    onClick: onClick,
    onError: onError,
    loading: loading,
    fetchpriority: fetchpriority,
    "data-testid": 'image-img-test-id'
  }));
};
var _default = exports["default"] = Image;